import { Box, CardMedia, Divider, Stack, Typography } from '@mui/material';
import CaretDownIcon from '../icons/CaretDownIcon';
import { DEFAULT_IMG_SOURCE } from 'modules/material/MaterialItem';

type Props = {
  src: string;
};

const AdsReceipt = (props: Props) => {
  const { src } = props;
  return (
    <Stack>
      <Stack direction="row" justifyContent="center" alignContent="center" gap={2} m={1.5}>
        <Box maxWidth="4rem" height="4rem">
          <CardMedia
            src={src}
            onError={e => (e.currentTarget.src = DEFAULT_IMG_SOURCE)}
            component="img"
            width="100%"
            height="100%"
          />
        </Box>
        <Typography variant="body2">Glaciset 10B, 1, 2800, Kongens Lyngby</Typography>
        <CaretDownIcon />
      </Stack>
      <Divider />
      <Stack direction="row" justifyContent="space-between" m={1.5}>
        <Box>
          <Typography variant="body2">Liebhaver Campaign</Typography>
          <Typography variant="body2">25% Display, 75% SoME</Typography>
          <Typography variant="body2">Start: 01/01/2024</Typography>
          <Typography variant="body2">Ends: 01/01/2024</Typography>
        </Box>
        <Typography variant="body2">x1</Typography>
      </Stack>
    </Stack>
  );
};

export default AdsReceipt;
